import React, { Component } from 'react'

import style from './style.css'

class FlexAlign extends Component {
  render() {
    return (
        <div className={style.flexAlign}>
            {this.props.children}
        </div>  
    )
  }
}

export default FlexAlign


// WEBPACK FOOTER //
// ./src/components/atoms/FlexAlign/index.js